exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Answer module should live here.\n * Import as neede like so:\n * ...\n * import answerStyles from 'answerModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"answer-item\">\n * ...\n */\n\n.modules-answer-___answerModuleStyles__answer-item___3-u3W {\n\n}\n", ""]);

// exports
exports.locals = {
	"answer-item": "modules-answer-___answerModuleStyles__answer-item___3-u3W"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/answer/answerModuleStyles.css
// module id = 1344
// module chunks = 1